import React from 'react';
import { ListItem, RadioButtonWrapper } from './styled';
import { Link } from '@chegg-ui/link';
import { useDispatch } from 'react-redux';
import { MopDisplayContent } from '../MopDisplayContent';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { setSelectedMop } from '../../redux/MopOnFileState/MopOnFileState.actions';
import { setModeClickHandler } from '../DefaultMopView/helpers';
import { AppMode } from '../../redux/AppModeState/AppModeState.types';
import { getString } from '../../constants/Strings';
import { ElementType, sendRioEvent, SpecType, SubType } from '@chegg/commerce-utils';
import { sendRioEventCallback } from '../../utils/CallbackUtils';
import { useAppSelector } from '../../hooks/useAppSelector';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { getPaymentFieldLabelText } from '../PaymentForm/helpers';
import { PaymentFormDataFields } from '../UserAddress/constants';
var MopListItem = function MopListItem(props) {
  var mop = props.mop,
    checked = props.checked,
    rioNamespace = props.rioNamespace;
  var description = mop.description,
    cardId = mop.cardId,
    cardIdHash = mop.cardIdHash,
    canUpdate = mop.canUpdate,
    last4 = mop.last4;
  var config = useAppSelector(configSelector);
  var paymentForm = config.paymentForm;
  var dispatch = useDispatch();
  var creditCardDescriptionDataTest = "".concat(DataTestAttributes.EXISTING_CARD_CONTAINER, "-").concat(last4);
  function radioClickHandler() {
    //Rio logging: When user selects among different MOPs using radio button
    sendRioEvent({
      info: getString('APP.RIO.EVENTS.EL_NAME.MOP_RADIO_BUTTON_CLICKED'),
      specType: SpecType.INTERACTION,
      subType: SubType.CLICK,
      elementType: ElementType.RADIO,
      callback: sendRioEventCallback,
      namespace: rioNamespace
    });
    dispatch(setSelectedMop({
      mop: mop
    }));
  }
  var editMopClickHandler = function editMopClickHandler(event) {
    event.preventDefault();
    // on click of edit, if mop is not selected, select it
    dispatch(setSelectedMop({
      mop: mop
    }));
    setModeClickHandler(AppMode.EDIT, AppMode.LIST_MOPS, dispatch);
  };
  var renderRadioButton = function renderRadioButton() {
    return /*#__PURE__*/React.createElement(RadioButtonWrapper, {
      inputId: cardId,
      name: 'mopList',
      defaultChecked: checked,
      onClick: radioClickHandler,
      "data-test": "".concat(last4 ? creditCardDescriptionDataTest : DataTestAttributes.EXISTING_PAYPAL_DESCRIPTION)
    }, /*#__PURE__*/React.createElement(MopDisplayContent, {
      mop: mop,
      ariaDescribedById: cardIdHash
    }));
  };
  return /*#__PURE__*/React.createElement(ListItem, null, renderRadioButton(), canUpdate && /*#__PURE__*/React.createElement(Link, {
    "data-test": "".concat(DataTestAttributes.EDIT_CARD_SELECTION, "-").concat(last4),
    hasButtonBehavior: true,
    href: '#',
    onClick: editMopClickHandler,
    title: "Edit ".concat(description),
    "aria-describedby": "logo:".concat(cardIdHash, " description:").concat(cardIdHash),
    role: 'button'
  }, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.EDIT) || getString('APP.MOPONFILE.EDIT')));
};
export default /*#__PURE__*/React.memo(MopListItem);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/MopListItem/index.js
// module id = 4572
// module chunks = 11